export default __webpack_public_path__ + "static/poster-748077c143821c38c3ec8b8a56c16bbc.png";